import React from 'react';
import { useApp } from '../../../context/AppContext';
import styles from './SuccessModal.module.css';

/**
 * Global success modal — displayed after any form submission.
 * Controlled by AppContext.
 */
function SuccessModal() {
  const { modalOpen, closeModal } = useApp();

  if (!modalOpen) return null;

  function handleOverlayClick(e) {
    if (e.target === e.currentTarget) closeModal();
  }

  return (
    <div
      className={styles.overlay}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className={styles.box}>
        <div className={styles.icon} aria-hidden="true">🎉</div>
        <h3 id="modal-title" className={styles.title}>Đăng ký thành công!</h3>
        <p className={styles.body}>
          Annie đã nhận được thông tin của bạn. Chúng tôi sẽ liên hệ lại trong vòng{' '}
          <strong>24 giờ</strong> để xác nhận lịch học thử. Hẹn gặp bạn sớm nhé! 🌸
        </p>
        <button className={styles.closeBtn} onClick={closeModal}>
          Tuyệt vời!
        </button>
      </div>
    </div>
  );
}

export default SuccessModal;
